export default {
  // QR 생성기
  'qr.generator_title': 'PC QR 로그인',
  'qr.generator_subtitle': '모바일에서 QR 코드를 스캔하세요',
  'qr.login_success': '로그인 성공!',
  'qr.redirecting_dashboard': '대시보드로 이동합니다...',
  'qr.time_remaining': '남은 시간',
  'qr.how_to_use': '사용 방법',
  'qr.step_1': '모바일에서 로그인하세요',
  'qr.step_2': 'QR 스캔 메뉴를 선택하세요',
  'qr.step_3': '이 QR 코드를 스캔하세요',
  'qr.back_to_login': '로그인 페이지로 돌아가기',

  // QR 링크
  'qr.checking': 'QR 코드 확인 중...',
  'qr.redirecting_remote': '리모컨 화면으로 이동합니다...',
  'qr.welcome': 'Qpresen에 오신 것을 환영합니다!',
  'qr.welcome_subtitle': '프레젠테이션을 더 스마트하게',
  'qr.login_required': '로그인이 필요합니다',
  'qr.login_required_desc': 'QR 코드로 PC와 연결하려면 먼저 회원가입 또는 로그인을 해주세요.',
  'qr.feature_remote': '모바일 리모컨',
  'qr.feature_remote_desc': '스마트폰으로 발표를 제어하세요',
  'qr.feature_laser': '레이저 포인터',
  'qr.feature_laser_desc': '터치로 레이저 포인터를 조작하세요',
  'qr.feature_timer': '발표 타이머',
  'qr.feature_timer_desc': '발표 시간을 실시간으로 확인하세요',
  'qr.signup_action': '회원가입하기',
  'qr.has_account_login': '이미 계정이 있으신가요? 로그인',
  'qr.error_invalid': '유효하지 않은 QR 코드',
  'qr.error_invalid_desc': 'QR 코드 정보가 올바르지 않습니다.',
  'qr.error_expired': 'QR 코드가 만료되었습니다',
  'qr.error_expired_desc': 'PC에서 새로운 QR 코드를 생성해주세요.',
  'qr.error_used': '이미 사용된 QR 코드',
  'qr.error_used_desc': 'PC에서 새로운 QR 코드를 생성해주세요.',
  'qr.error_not_found': 'QR 코드를 찾을 수 없습니다',
  'qr.error_not_found_desc': 'PC에서 새로운 QR 코드를 생성해주세요.',
  'qr.go_home': '홈으로 돌아가기',
  'qr.processing_error': 'QR 처리 중 오류가 발생했습니다.',

  // QR 스캐너
  'qr.scan_title': 'QR 스캔',
  'qr.scan_subtitle': 'PC의 QR 코드를 스캔하세요',
  'qr.login_required_scan': 'QR 스캔을 사용하려면 먼저 로그인이 필요합니다.',
  'qr.login_action': '로그인하기',
  'qr.go_home_action': '홈으로 돌아가기',
  'qr.camera_permission_required': '카메라 권한이 필요합니다',
  'qr.camera_permission_desc': 'QR 스캔을 사용하려면 브라우저 설정에서 카메라 권한을 허용해주세요.',
  'qr.permission_settings': '권한 설정 방법',
  'qr.permission_step_1': '브라우저 주소창 왼쪽의 <strong>자물쇠 아이콘</strong> 또는 <strong>설정 아이콘</strong>을 탭하세요',
  'qr.permission_step_2': '<strong>사이트 설정</strong> 또는 <strong>권한</strong>을 선택하세요',
  'qr.permission_step_3': '<strong>카메라</strong> 항목을 찾아 <strong>허용</strong>으로 변경하세요',
  'qr.permission_step_4': '설정 후 아래 <strong>다시 시도</strong> 버튼을 눌러주세요',
  'qr.ios_safari_user': 'iOS Safari 사용자',
  'qr.ios_safari_hint': '설정 앱 → Safari → 카메라 → 허용',
  'qr.retry_action': '다시 시도하기',
  'qr.back_to_dashboard': '대시보드로 돌아가기',
  'qr.select_presentation': '프레젠테이션 선택',
  'qr.select_presentation_desc': '리모컨으로 사용할 프레젠테이션을 선택하세요',
  'qr.auth_complete': 'QR 인증 완료! 프레젠테이션을 선택하세요.',
  'qr.loading_list': '목록을 불러오는 중...',
  'qr.no_presentations': '프레젠테이션이 없습니다.',
  'qr.no_presentations_hint': 'PC에서 먼저 PDF를 업로드해주세요.',
  'qr.align_qr': 'QR 코드를 프레임 안에 맞춰주세요',
  'qr.camera_preparing': '카메라 준비 중...',
  'qr.scan_again': '다시 스캔하기',
  'qr.scanning': '스캔 중...',
  'qr.tip': '팁',
  'qr.tip_desc': 'PC 화면의 QR 코드를 카메라에 비추면 자동으로 인식됩니다.',
  'qr.camera_unavailable': '카메라를 사용할 수 없습니다. 다른 앱에서 카메라를 사용 중인지 확인해주세요.',
  'qr.invalid_qr': '유효하지 않은 QR 코드입니다.',
  'qr.login_first': '먼저 로그인이 필요합니다.',
  'qr.qr_not_found': 'QR 코드를 찾을 수 없습니다.',
  'qr.qr_already_used': '이미 사용된 QR 코드입니다.',
  'qr.qr_expired': '만료된 QR 코드입니다.',
  'qr.qr_not_found_timeout': 'QR 코드를 찾을 수 없습니다. 다시 시도해주세요.',
  'qr.qr_scan_error': 'QR 코드 처리 중 오류가 발생했습니다.',
};
